import { LitElement } from "lit";
import { property, state } from "lit/decorators.js";
import { pushEvent } from "./analytics.js";

export abstract class LeadMagnetWidgetBase extends LitElement {
  @property({ type: String })
  public slug = "";

  @property({ type: String })
  public source = "";

  @state()
  protected isLoading = false;

  @state()
  protected errorMessage = "";

  private get sanitizedSlug(): string {
    return this.slug.replace(/-/g, "_");
  }

  private get eventContext(): Record<string, unknown> {
    return { slug: this.sanitizedSlug, leadMagnet: this.sanitizedSlug, source: this.source };
  }

  public override connectedCallback(): void {
    super.connectedCallback();
    pushEvent("lm_widget_loaded", this.eventContext);
  }

  protected trackStep(step: string, data?: Record<string, unknown>): void {
    pushEvent("lm_step_completed", { ...this.eventContext, step, ...data });
  }

  protected trackSubmit(data?: Record<string, unknown>): void {
    pushEvent("lm_form_submitted", { ...this.eventContext, ...data });
  }

  protected trackError(step: string, error: string, data?: Record<string, unknown>): void {
    pushEvent("lm_form_error", { ...this.eventContext, step, error, ...data });
  }

  protected trackResult(data?: Record<string, unknown>): void {
    pushEvent("lm_result_viewed", { ...this.eventContext, ...data });
  }

  protected trackCustomEvent(event: string, data?: Record<string, unknown>): void {
    pushEvent(event, { ...this.eventContext, ...data });
  }

  protected startLoading(): void {
    this.isLoading = true;
    this.errorMessage = "";
  }

  protected stopLoading(): void {
    this.isLoading = false;
  }

  protected setError(message: string): void {
    this.errorMessage = message;
  }
}
